import { AxiosResponse } from 'axios';
import {
  AdministrationFilters,
  IAdminInfo,
  IEditAdmin,
  IRegistrationAdmin
} from 'types/administration.types';
import { HydraListResponse, LoadListDataParams } from 'hooks/useListData';
import api from 'utils/apiClient';

export const createAdmin = (data: Omit<IRegistrationAdmin, 'confirm'>): Promise<IAdminInfo> => {
  return api.post('/admins/create', data);
};

export const loadAdmins = ({ pageSize, createdAt, ...rest }: LoadListDataParams<AdministrationFilters>): Promise<AxiosResponse<HydraListResponse<IAdminInfo>>> => {
  let params: any = { ...rest, itemsPerPage: pageSize };
  if (createdAt) {
    if (createdAt[0]) {
      params['createdAt[after]'] = createdAt[0].toISOString();
    }
    if (createdAt[1]) {
      params['createdAt[before]'] = createdAt[1].toISOString();
    }
  }
  return api.get('/admins', { params });
};

export const editAdmin = ({ id, ...data }: IEditAdmin): Promise<AxiosResponse<IAdminInfo>> => {
  return api.post(`/admins/edit/${id}`, data);
};

export const deleteAdmin = ({ id }: IAdminInfo): Promise<any> => {
  return api.delete(`/admins/${id}`);
};